import React from 'react';
import { T } from '@transifex/react';

import { AlertTriangle } from 'src/ui-new/icons';
import { PageShell } from 'src/components/shared/PageShell';
import { EmptyState } from 'src/components/shared/EmptyState';

/**
 * Full-page "you don't have permission" state for capability-denied routes.
 * Reuses the shared PageShell (which provides the `wh-ui` scope) + EmptyState.
 *
 * The body copy is byte-identical to the pools NOT_AUTHORIZED string
 * (`pools/components/poolError.ts:13`, curly apostrophe) so the two share one
 * Transifex source entry.
 */
export const Forbidden: React.FC<{
  title?: React.ReactNode;
  action?: { label: React.ReactNode; onClick: () => void };
}> = ({ title, action }) => (
  <PageShell title={title ?? <T _str="Not available" />}>
    <EmptyState
      icon={AlertTriangle}
      title={<T _str="You don’t have permission to do that." />}
      action={action}
    />
  </PageShell>
);
